import React, { Component } from 'react';
import ComponentContract from '../contract/index/ComponentContract';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  componentWillMount() {}

  handleClick = e => {};

  render() {
    return (
      <div className="mb16" id="contract">
        <ComponentContract {...this.props} dimenUuid={{ incubatorUuid: this.props.params.uuid }} />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/one/PageContract.js